import { QUERY_KEYS } from 'api/query-keys';
import { shiftClaimService } from 'ogp/services';
import { ShiftClaimSettlement } from 'ogp/services/shift-claim-service.types';
import { useMutation, useQueryClient } from 'react-query';

export function useSettleCheckouts() {
  const queryClient = useQueryClient();

  return useMutation(
    async (settlements: ShiftClaimSettlement[]) =>
      await shiftClaimService.settleCheckouts(settlements),
    {
      onSuccess: () => {
        // Wait for the refetch to be done so we have an updated screen after approving.
        queryClient.invalidateQueries(QUERY_KEYS.checkouts());
      },
    }
  );
}
